import { IPageableResponse } from "@common/pagination/IPageable";
import { ITransaction } from "../interface/ITransactionHistory";

interface ITransactionResponse {
    amount: number;
    dateTime: string;
    reference: string;
    transactionType: string;
    paymentCorrelationTransactionUuid: string;
}

export interface IPageableTransactionsHistoryResponse {
    transactionsPage: IPageableResponse<ITransactionResponse>;
}

export const getResponseToState = (
    response: IPageableTransactionsHistoryResponse
): IPageableResponse<ITransaction> => ({
    content: response.transactionsPage.content.map((transaction) => ({
        amount: transaction.amount,
        dateTime: transaction.dateTime,
        reference: transaction.reference,
        transactionType: transaction.transactionType,
        paymentCorrelationTransactionUuid: transaction.paymentCorrelationTransactionUuid,
    })),
    totalPages: response.transactionsPage.totalPages,
});
